import {
    Box,
    Dialog,
    Divider,
} from '@mui/material';
import { useState } from "react";
import { Swiper, SwiperSlide, FreeMode } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import MenuIcon from '@mui/icons-material/Menu';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import "swiper/swiper-bundle.css";

SwiperCore.use([Pagination])

function HelpCouponCode() {

    const [open, setOpen] = useState(false);
    const openClick = () => {
        setOpen(true);
    };
    const closeClick = () => {
        setOpen(false);
    };

    return (
        <>
            <Dialog fullScreen open={open} onClose={closeClick} >
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '25px 0 0 10px',
                            fontSize: '22px'
                        }}>
                        쿠폰 코드 사용 방법
                    </Box>
                </Box>
                <Divider />
                <Swiper
                    grabCursor={true}
                    slidesPerView={1}
                    className="mySwiper"
                    pagination={{ clickable: true }}
                    style={{
                        width: '100%',
                        height: '100%',
                        zIndex: '1',
                        // '.swiper-pagination': {
                        //     position: 'fixed !important',
                        // },
                        overflow: 'scroll'
                    }}
                >

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '100px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    쿠폰 코드로 사은품을 신청할 수 있습니다.
                                </Box>
                                <Box
                                    sx={{
                                        marginTop: '10px'
                                    }}>
                                    스마트몰은 인터넷 주소창에 'smartmall.kr' 을 입력하면 갈 수 있습니다.
                                </Box>
                                {/* <Box>
                                    쿠폰코드 옆의 스마트몰 버튼 클릭 시 들어갈 수 있습니다.
                                </Box> */}
                            </Box>
                        </Box>
                        {/* <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help01.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box> */}
                        <Box sx={{ height: 50 }}></Box>
                    </SwiperSlide>
                    

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                // marginBottom: '0',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                    메뉴 버튼(<MenuIcon fontSize='14px' />)을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help02.png'
                                style={{
                                    height: '500px'
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    아이디가 있는 경우 로그인을 합니다.
                                </Box>
                                <Box>
                                    아이디가 없는 경우 회원가입 후 로그인을 합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help03.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    로그인 후 메뉴에서 마이페이지를 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help04.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    마이페이지에서 'Coupon 쿠폰'을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help05.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    쿠폰인증번호 등록하기 하단의 박스에 쿠폰코드를 기입한 후 쿠폰번호인증 버튼을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help06.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    마이쿠폰 목록에서 사용할 쿠폰의 상세(화살표)를 클릭합니다.
                                </Box>
                                <Box
                                    sx={{
                                        marginTop: '10px'
                                    }}>
                                    적용상품보기 버튼을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help07.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    적용가능한 상품을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help08.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    상품페이지에서 BUY NOW 버튼을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help09.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    필수 항목과 수량 등을 지정한 후 구매하기 버튼을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help10.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    결제정보 기입 후 '할인/부가결제' 항목 중 '쿠폰 할인'란에서 '쿠폰 적용' 버튼을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help11.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    주문서 쿠폰 하단의 '선택하세요'란을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help12.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    사용할 쿠폰 선택 후 적용 버튼을 클릭합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help13.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '0 20px',
                                padding: '20px 20px 0',
                                borderRadius: '5px',
                                height: '80px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    주문/결제 페이지에서 결제금액 확인 후 페이지 최하단의 결제하기 버튼을 클릭합니다.
                                </Box>
                                <Box>
                                    절차를 따라 결제를 진행합니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/fre_help14.png'
                                style={{
                                    height: '500px',
                                }} />
                        </Box>
                    </SwiperSlide>

                </Swiper>
                
            </Dialog>

            <Box
                sx={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    // width: '155px',
                    // justifyContent: 'center'
                }}>
                <Box
                    sx={{
                        fontSize: '13px'
                    }}>
                    쿠폰코드
                </Box>
                <HelpOutlineIcon
                    sx={{
                        padding: '3px 3px',
                        // marginTop: '5px'
                    }}
                    fontSize="20px"
                    color="action"
                    onClick={openClick} />
            </Box>

        </>
    )
}

export default HelpCouponCode;